
/**
 * Paralax
 * @module Paralax
 *
 * @param {array} datas
 *
 */

/* eslint-disable */
function Paralax(datas){
    var wh;
    const items = [];
    const isMobile = window.innerWidth < 768 ? true : false;

    datas.forEach(data => {
        document.querySelectorAll(...data.el).forEach(el => {
            items.push({
                el: el,
                height: el.clientHeight,
                top: el.getBoundingClientRect().top,
                strength: isMobile ? data.strenght/3 : data.strenght,
                img: el.querySelector('img'),
                type: data.type || 'paralax'
            });
        })
    });

    const resize = () =>  {
        wh = window.innerHeight;
        items.forEach(item => {
            item.height = item.el.clientHeight;
            item.top =  item.el.getBoundingClientRect().top;
        });
    };

    const type = {
        imgBgOffset: (item, value) => {
            const percent = (value - item.top + wh) / (wh + item.height);
            if(percent >= 0 && percent <= 1) {
                item.img.style.transform = `matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,${(percent) * 2 * item.strength - item.strength},0,1)`;
            }
        },
        paralax: (item, value) => {
            const percent = (value - item.top + wh) / (wh + item.height);
            if(percent >= -.05 && percent <= 1.05) {
                item.el.style.transform = `matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,${(percent - .5) * item.strength},0,1)`;
            }
        }
    };

    this.run = scrollY => {
        for(const item of items){
            type[item.type](item, scrollY);
        }
    }

    window.addEventListener('resize', resize);
    resize();
};

export default Paralax;
